import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";

export function useRestaurantBookmark(restaurantId: string) {
  const queryClient = useQueryClient();

  const toggleMutation = useMutation({
    mutationFn: async () => {
      const response = await apiRequest("POST", "/api/bookmarks/toggle", { restaurantId });
      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['/api/user/bookmarks'] });
    },
  });

  return {
    toggleBookmark: toggleMutation.mutate,
    isToggling: toggleMutation.isPending,
  };
}

export function useUserBookmarks() {
  return useQuery<any[]>({
    queryKey: ['/api/user/bookmarks'],
  });
}

export function useIsRestaurantBookmarked(restaurantId: string) {
  const { data: bookmarks } = useUserBookmarks();
  return bookmarks?.some(b => b.restaurantId === restaurantId) ?? false;
}
